import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const AnimatedHeadings = () => {
  const [textIndex, setTextIndex] = useState(0);
  const [paragraphIndex, setParagraphIndex] = useState(0);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  const textLines = [
    { line1: "POWERING PROGRESS", line2: "ACROSS INDUSTRIES" },
    { line1: "BEYOND ALGORITHMS", line2: "AI THAT DELIVERS RESULTS" },
  ];

  const paragraphs = [
    "Cutting edge solutions in Healthcare, Lifesciences, \n and Aerospace because AI is only as powerful as its impact",
    "From intelligence automation to predictive analytics, \n we design AI that thinks, learns, and evolves",
  ];

  // Interval effect WITHOUT dependency warning
  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % textLines.length);
      setParagraphIndex((prev) => (prev + 1) % paragraphs.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [textLines.length, paragraphs.length]);

  // Track viewport width
  useEffect(() => {
    const update = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const isMobileViewport = viewportWidth <= 500;

  const renderParagraphText = (text) =>
    text.split("\n").map((line, index) => <p key={index}>{line}</p>);

  // handlers MUST be defined BEFORE they are used
  const handleNext = () => {
    setTextIndex((prev) => (prev + 1) % textLines.length);
    setParagraphIndex((prev) => (prev + 1) % paragraphs.length);
  };

  const handlePrev = () => {
    setTextIndex((prev) => (prev - 1 + textLines.length) % textLines.length);
    setParagraphIndex((prev) => (prev - 1 + paragraphs.length) % paragraphs.length);
  };

  return (
    <div className="relative w-full h-full flex flex-col text-white">

      {/* Paragraph */}
      <div
  className="absolute top-1/4 mt-24 right-[10%] max-w-xl text-justify z-10"
  style={{
    fontSize: isMobileViewport ? "1.0rem" : "1.37rem",
  }}
>
  {renderParagraphText(paragraphs[paragraphIndex])}
</div>


      {/* Headings */}
      <div
        className="absolute bottom-[calc(15%-3.3rem)] z-10 text-left"
        style={{
          left: isMobileViewport ? "3%" : "12%" // <-- final working logic
        }}
      >
        <h1 className="text-5xl md:text-7xl font-bold leading-tight">
          {textLines[textIndex].line1}
        </h1>

        <h2
  className="font-extrabold inline-block mt-4"
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "2px #ffffff",
    WebkitTextFillColor:
      navigator.maxTouchPoints > 0 ? "#ffffff" : "transparent", // mobile fill / desktop transparent
    color: navigator.maxTouchPoints > 0 ? "#ffffff" : "transparent",
    fontSize: "4rem", // same h2 size as you set earlier
    letterSpacing: "0.05em",
    lineHeight: "1.1",
    whiteSpace: "nowrap",
  }}
>
  {textLines[textIndex].line2}
</h2>



      </div>

      {/* Left Arrow */}
      <button
        onClick={handlePrev}
        className="absolute left-0 top-1/2 -translate-y-1/2
               w-16 h-16 flex items-center justify-center
               hover:bg-white/30 transition z-20 -ml-2"
      >
        <ChevronLeft className="text-white w-8 h-8" />
      </button>

      {/* Right Arrow */}
      <button
        onClick={handleNext}
        className="absolute right-0 top-1/2 -translate-y-1/2 
               w-16 h-16 flex items-center justify-center 
               hover:bg-white/30 transition z-20"
      >
        <ChevronRight className="text-white w-8 h-8" />
      </button>

    </div>
  );
};

export default AnimatedHeadings;